import { toast, ToastOptions } from 'react-toastify';
import React from 'react';

const baseOpts: ToastOptions = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: false,
    theme: 'dark',
};

export function notify(
    type: string | 'success' | 'error',
    icon: React.ReactNode,
    content: string | React.ReactNode,
    duration?: number
) {
    const opts: ToastOptions = {
        ...baseOpts,
        autoClose: duration ?? baseOpts.autoClose,
        icon: () => icon,
    };

    switch (type) {
        case 'success':
            toast.success(content || 'Success!', {
                ...opts,
                className: 'fluent-toast fluent-toast-success',
            });
            break;
        case 'error':
            toast.error(content || 'Failed!', {
                ...opts,
                className: 'fluent-toast fluent-toast-error',
            });
            break;
        default:
            toast(content || '', {
                ...opts,
                className: 'fluent-toast',
            });
    }
}
